<template>
    <div class="input-group">
        <span
            v-if="showIcon === undefined || showIcon"
            class="input-group-text"
            :class="body ? 'bg-danger text-white' : ''"
        >
            <svg :width="iconSize" :height="iconSize" fill="currentColor">
                <use :xlink:href="'/assets/icons/bootstrap-icons.svg#' + icon" />
            </svg>
        </span>
        <textarea
            class="form-control"
            :class="'is-' + (body ? 'invalid' : 'valid')"
            :placeholder="placeholder"
            :rows="rows"
            autocomplete="off"
            @input="$emit('update:modelValue', $event.target.value)"
            @keyup="$emit('validate')"
            @blur="$emit('validate')"
            @change="$emit('onChange', $event)"
        >{{ modelValue }}</textarea>
        <div
            :class="(body ? 'invalid' : 'valid') + '-feedback'"
            v-if="(showErrorInfo === undefined || showErrorInfo) && body"
            v-html="body"
        ></div>
    </div>
</template>


<script>
    export default {
        name: 'ValidateTextarea',
        props: {
            modelValue: null,
            showIcon: {
                type: Boolean,
                default: true,
            },
            icon: {
                type: String,
                default: "info",
            },
            iconSize: {
                type: Number,
                default: 20,
            },
            rows: {
                type: Number,
                default: 5,
            },
            showErrorInfo: {
                type: Boolean,
                default: true,
            },
            body: {
                type: String,
                default: "",
            },
            placeholder: {
                type: String,
                default: "",
            },
        },
        setup() {
            // const inputTextField = ref(props.modelValue);
            // return {
            //     inputTextField,
            // };
        },
    };
</script>


<style lang="scss" scoped>
.is-valid{
    background-size: calc(.55em + .175rem) calc(.55em + .175rem);
}
.form-control::placeholder{
    font-size: 9pt;
}
</style>
